/* eslint-disable */
import React from 'react'
import {message} from 'antd'
import http from '../../Component/Interceptor/Interseptor'
import {Link} from 'react-router-dom'
import Page from '../../Component/Pagination/Pagination'
import HeaderTable from '../../Component/BaseComponent/HeaderTable'
import {Button, Modal, ModalBody, ModalFooter, ModalHeader} from 'mdbreact'
import cookie from 'react-cookies'
import CRM from '../BaseComponent/CRM'
import jMoment from 'moment-jalaali'
import HeaderTablePrint from '../BaseComponent/HeaderTablePrint'
import ExcelExport from '@progress/kendo-react-excel-export/dist/npm/ExcelExport'

class ReportSubject extends React.Component {
  constructor(props) {
    super(props)
    this.state = {
      subjectTypes: [],
      deleteModal: false,
      editModal: false,
      subjectName: '',
      subjectEnable: '',
      subjectId: '',
      categoryId: '',
      categoryList: [],
      printInfo: []
    }
  }

  callReportSubject = () => {
    http.get(`${CRM.CRM_CONTACT_SUBJECT_REPORT}`, {}).then((response) => {
      if (response.data.error == null) {
        // alert(JSON.stringify(response.data))
        this.setState({
          subjectTypes: response.data.object.result,
          total: response.data.object.countAll
        })
      } else {
        this.setState({
          subjectTypes: []
        })
      }
    })
  }

  componentDidMount() {
    sessionStorage.setItem('pageNumber', '1')
    sessionStorage.setItem('dropDownVal', '10')

    this.callReportSubject()

    http.get(`${CRM.CRM_CONTACT_CATEGORY_LIST}`, {}).then((response) => {
      // alert(JSON.stringify(response.data))
      if (response.data.error == null) {
        this.setState({
          categoryList: response.data.object
        })
      } else {
        this.setState({
          categoryList: []
        })
      }
    })
  }

  onResultFetched(data) {
    this.setState({
      subjectTypes: data
    })
  }

  changeDropDown(data) {
    this.setState({
      subjectTypes: data,
      lengthProducts: this.state.total
    })
  }

  deletesubject = (id, name) => {
    sessionStorage.setItem('subjectId', id)
    this.setState({
      deleteModal: !this.state.deleteModal,
      subjectName: name
    })
  }
  toggleDelete = () => {
    sessionStorage.removeItem('subjectId')

    this.setState({
      deleteModal: !this.state.deleteModal,
      subjectName: ''
    })
  }
  deleteCancel = () => {
    sessionStorage.removeItem('subjectId')

    this.setState({
      deleteModal: !this.state.deleteModal,
      subjectName: ''
    })
  }
  deleteOk = () => {
    let contactSubjectId = sessionStorage.getItem('subjectId')
    let data = {
      contactSubjectId
    }
    http.post(`${CRM.CRM_CONTACT_SUBJECT_REMOVE}`, data, {}).then((response) => {
      if (response.data.error == null) {
        message.success('خانواده تماس با موفقیت حذف شد')
        this.deleteCancel()
        this.callReportSubject()
      } else {
        message.error(response.data.description)
      }
    })
  }

  editsubject = (id, name, enable, categoryId) => {
    this.setState({
      editModal: !this.state.editModal,
      subjectId: id,
      subjectName: name,
      subjectEnable: enable,
      categoryId
    })
  }
  editCancel = () => {
    this.setState({
      editModal: !this.state.editModal,
      subjectId: '',
      subjectName: '',
      subjectEnable: ''
    })
  }
  toggleEdit = () => {
    this.editCancel()
  }
  editOk = () => {
    var name = document.getElementById('name').value
    var contactCategoryId = document.getElementById('contactCategoryId').value
    var enabled = document.getElementById('enabled').value
    let data = {
      name,
      enabled,
      contactSubjectId: this.state.subjectId,
      contactCategoryId
    }

    http.post(`${CRM.CRM_CONTACT_SUBJECT_UPDATE}`, data, {}).then((response) => {
      if (response.data.error === null) {
        message.success('ویرایش با موفقیت انجام شد')
        this.editCancel()
        this.callReportSubject()
      } else {
        message.error(response.data.description)
      }
    })
  }

  exportExcel = () => {
    http
      .get(
        `${CRM.CRM_CONTACT_SUBJECT_REPORT}?export=true&pageSize=10&pageNumber=1&${sessionStorage.getItem('params')}`,
        {}
      )
      .then((response) => {
        // alert(JSON.stringify(response.data))
        if (response.data.error == null) {
          console.log(response.data)
          // $('.showBaseTable,.print').fadeIn();

          sessionStorage.setItem('countAll', response.data.object.countAll)
          this.setState({
            excelReport: response.data.object.result
          })
          let {excelReport} = this.state
          for (let i = 0; i < excelReport.length; i++) {
            if (excelReport[i]['enabled']) {
              excelReport[i]['enabled'] = 'فعال'
            } else {
              excelReport[i]['enabled'] = 'غیر فعال'
            }
          }

          this._export.save(this.state.excelReport)
        } else {
          this.setState({
            excelReport: []
          })
        }
      })
      .catch((error) => {
        // alert(JSON.stringify(error))
      })

    // this._export.save(excelData)
  }

  getPrintInfo = () => {
    http
      .get(`${CRM.CRM_CONTACT_SUBJECT_REPORT}?export=true&${sessionStorage.getItem('params')}`, {})
      .then((response) => {
        if (response.data.error == null) {
          this.setState({
            printInfo: response.data.object.result
          })
        }
      })
      .catch((error) => {
        alert(JSON.stringify(error))
      })
  }

  exportPrint = () => {
    var css = '@page { size:A4 portrait;}',
      head = document.head || document.getElementsByTagName('head')[0],
      style = document.createElement('style')

    style.type = 'text/css'
    style.media = 'print'

    if (style.styleSheet) {
      style.styleSheet.cssText = css
    } else {
      style.appendChild(document.createTextNode(css))
    }

    head.appendChild(style)
    this.getPrintInfo()
    setTimeout(() => {
      window.print()
    }, 2000)
  }

  render() {
    let pageNumber = sessionStorage.getItem('pageNumber')
    let dropDownVal = sessionStorage.getItem('dropDownVal')
    let printCol = ['ردیف', 'خانواده تماس', 'عنوان', 'وضعیت']

    return (
      <div className="rtl printA4Page">
        <div className="printSection">
          <table className="printTable printReportTable" ref={(node) => (this.printPart = node)}>
            <HeaderTablePrint
              header="ارتباط با مشتری - موضوع های تماس"
              headerColSpan={4}
              reporter={cookie.load('name')}
              timePrint={jMoment().format('jYYYY/jM/jD HH:mm')}
              leftColSpan={4}
              rightColSpan={1}
              centerColSpan={1}
              centerSection={''}
              rightSection={''}
              columns={printCol}
            />
            <tbody>
              {this.state.printInfo.map((media, index) => (
                <tr key={'i' + index}>
                  <td>{index + 1}</td>
                  <td>{media.contactCategoryName}</td>

                  <td>{media.contactSubjectName}</td>
                  <td>{media.enabled ? 'فعال' : 'غیر فعال'}</td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
        <div className="excelSection">
          <ExcelExport
            dir="rtl"
            ref={(exporter) => {
              this._export = exporter
            }}
            fileName="ارتباط با مشتری - موضوع های تماس.xls"
          >
            <grid style={{height: '420px'}} data={this.state.excelReport}>
              <gridColumn
                key={'contactCategoryName'}
                field={'contactCategoryName'}
                title={'خانواده تماس'}
                width="100px"
                footerCellOptions={{wrap: true, textAlign: 'center'}}
              />
              <gridColumn
                key={'contactSubjectName'}
                field={'contactSubjectName'}
                title={'عنوان'}
                width="100px"
                footerCellOptions={{wrap: true, textAlign: 'center'}}
              />
              <gridColumn
                key={'enabled'}
                field={'enabled'}
                title={'وضعیت'}
                width="100px"
                footerCellOptions={{wrap: true, textAlign: 'center'}}
              />
            </grid>
          </ExcelExport>
        </div>

        <div className="wrapperIframe">
          <ul className="breadcrumb">
            <li>
              <Link to={'/search'}>به روزرسان</Link>
            </li>
            <li>اطلاعات پایه</li>
            <li>ارتباط با مشتری</li>
            <li>موضوع های تماس</li>
          </ul>

          <div className="tableComponent">
            <div className="tableTools">
              <div className="tableOptionWrapp">
                <HeaderTable
                  addUrl="/addSubject"
                  url={CRM.CRM_CONTACT_SUBJECT_REPORT}
                  ChangeDropDown={this.changeDropDown.bind(this)}
                  printUrl=""
                  printComponent={this.printTable}
                  execelUrl={CRM.CRM_CONTACT_SUBJECT_REPORT + '?export=true'}
                  excelColumns={[]}
                  titleAdd="افزودن شهر"
                  printLink=""
                />
                <button className={'printButton'} onClick={this.exportExcel}>
                  <i className="fas fa-file-excel" />
                </button>
                <button className="printButton" onClick={this.exportPrint}>
                  <i className="fas fa-print" />
                </button>
              </div>
            </div>
            <div className="showBaseTable">
              <table className="baseTable">
                <tbody>
                  <tr className="firstRow">
                    <td>ردیف</td>
                    <td>خانواده تماس</td>
                    <td>عنوان</td>
                    <td>وضعیت فعال</td>
                    <td>ویرایش</td>
                    <td>حذف</td>
                  </tr>

                  {this.state.subjectTypes.map((subject, index) => (
                    <tr key={index}>
                      <td>{(pageNumber - 1) * dropDownVal + index + 1}</td>
                      <td>{subject.contactCategoryName}</td>
                      <td>{subject.contactSubjectName}</td>
                      <td>
                        {subject.enabled ? (
                          <img src={require('../../image/confirm.svg')} alt="" />
                        ) : (
                          <img src={require('../../image/ignor.svg')} alt="" />
                        )}
                      </td>
                      <td>
                        <button
                          onClick={() =>
                            this.editsubject(
                              subject.contactSubjectId,
                              subject.contactSubjectName,
                              subject.enabled,
                              subject.contactCategoryId
                            )
                          }
                        >
                          <img src={require('../../image/editDriver.svg')} alt="" />
                        </button>
                      </td>
                      <td>
                        <button
                          onClick={() => this.deletesubject(subject.contactSubjectId, subject.contactSubjectName)}
                        >
                          <img src={require('../../image/trash.svg')} alt="" />
                        </button>
                      </td>
                    </tr>
                  ))}
                </tbody>
              </table>
              <div className="paginationWrapp">
                <Page
                  defaultCurrent={1}
                  total={this.state.total}
                  onResultFetched={this.onResultFetched.bind(this)}
                  url={CRM.CRM_CONTACT_SUBJECT_REPORT}
                />
              </div>
            </div>
          </div>
        </div>
        <Modal isOpen={this.state.deleteModal} toggle={this.toggleDelete} size="sm">
          <ModalHeader toggle={this.toggleDelete}>حذف موضوع تماس</ModalHeader>
          <ModalBody>
            <p className="titleSm">آیا از حذف موضوع تماس {this.state.subjectName} مطمئن هستید؟؟؟</p>
          </ModalBody>
          <ModalFooter>
            <button className="confirmBtnModal" onClick={this.deleteOk}>
              حذف موضوع تماس
            </button>
            <button className="cancelBtnModal" onClick={this.deleteCancel}>
              لغو
            </button>
          </ModalFooter>
        </Modal>

        <Modal isOpen={this.state.editModal} toggle={this.toggleEdit} size="sm">
          <ModalHeader toggle={this.toggleEdit}>ویرایش موضوع تماس</ModalHeader>
          <ModalBody>
            <div className="modalForm">
              <div className="formComponent">
                <label>خانواده تماس </label>
                <select className="form-control" id="contactCategoryId">
                  {this.state.categoryList.map((category, index) => (
                    <option
                      selected={this.state.categoryId === category.contactCategoryId ? true : false}
                      value={category.contactCategoryId}
                    >
                      {category.contactCategoryName}
                    </option>
                  ))}
                </select>
              </div>

              <div className="formComponent">
                <label> نام رسانه تماس: </label>
                <input className="form-control" type="text" defaultValue={this.state.subjectName} id="name" />
              </div>
              <div className="formComponent">
                <label> وضعیت رسانه تماس: </label>

                <select className="form-control" name="enabled" id="enabled">
                  <option selected={this.state.subjectEnable == 1 ? true : false} value={1}>
                    فعال
                  </option>
                  <option selected={this.state.subjectEnable == 0 ? true : false} value={0}>
                    غیر فعال
                  </option>
                </select>
              </div>
            </div>
          </ModalBody>
          <ModalFooter>
            <button className="confirmBtnModal" onClick={this.editOk}>
              ویرایش موضوع تماس
            </button>
            <button className="cancelBtnModal" onClick={this.editCancel}>
              لغو
            </button>
          </ModalFooter>
        </Modal>
      </div>
    )
  }
}

export default ReportSubject
